/**
 * @generated SignedSource<<bd626cf41196ae71b3902f2ba5179e83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type templateCatalogImportMutation$variables = {
  ecommerce: ECommerce;
  salesChannelID: string;
  salesChannelOfflineID: string;
  targetProductName: string;
  targetProductSKU: string;
  templateProductID: string;
};
export type templateCatalogImportMutation$data = {
  readonly importProductTemplate: number;
};
export type templateCatalogImportMutation = {
  response: templateCatalogImportMutation$data;
  variables: templateCatalogImportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ecommerce"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "salesChannelID"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "salesChannelOfflineID"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetProductName"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetProductSKU"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateProductID"
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ecommerce",
        "variableName": "ecommerce"
      },
      {
        "kind": "Variable",
        "name": "salesChannelID",
        "variableName": "salesChannelID"
      },
      {
        "kind": "Variable",
        "name": "salesChannelOfflineID",
        "variableName": "salesChannelOfflineID"
      },
      {
        "kind": "Variable",
        "name": "targetProductName",
        "variableName": "targetProductName"
      },
      {
        "kind": "Variable",
        "name": "targetProductSKU",
        "variableName": "targetProductSKU"
      },
      {
        "kind": "Variable",
        "name": "templateProductID",
        "variableName": "templateProductID"
      }
    ],
    "kind": "ScalarField",
    "name": "importProductTemplate",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "templateCatalogImportMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "templateCatalogImportMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "68197bb50c1f03215eef8779095e8e30",
    "id": null,
    "metadata": {},
    "name": "templateCatalogImportMutation",
    "operationKind": "mutation",
    "text": "mutation templateCatalogImportMutation(\n  $salesChannelOfflineID: String!\n  $templateProductID: String!\n  $targetProductSKU: String!\n  $targetProductName: String!\n  $salesChannelID: String!\n  $ecommerce: ECommerce!\n) {\n  importProductTemplate(salesChannelOfflineID: $salesChannelOfflineID, templateProductID: $templateProductID, targetProductSKU: $targetProductSKU, targetProductName: $targetProductName, salesChannelID: $salesChannelID, ecommerce: $ecommerce)\n}\n"
  }
};
})();

(node as any).hash = "5404f7b8a2c27291abe23d217664295e";

export default node;
